import { select } from "@assets/scripts/utils";

export default function (selector, options = {}) {
    select(selector).forEach(element => {
        const delay = element.getAttribute('data-delay') || 0
        const offset = element.getAttribute('data-offset') || '100%'
        new Waypoint({
            element: element,
            handler(dir) {
                if(!dir == 'down') return
                setTimeout(() => {
                    element.classList.add('animated')
                }, delay)
                this.destroy()
            },
            offset: offset
        })
    })
}
